import React, { Component } from 'react';
import './css/Note.css';
import firebase from '../Firebase.js'
import DB from '../db.js'
import {withRouter} from 'react-router';
import {
	NavLink
} from 'react-router-dom';
var moment = require('moment');

class Account extends Component {

	constructor(props) {
		
		super(props);
		this.state = {
			userSelected: {
				uid: null,
				data: null
			}
		};
		
		// Bind Allow access by "this" into the function
		//this.loadUsersFromDb = this.loadUsersFromDb.bind(this);
		this.addUsersIntoView = this.addUsersIntoView.bind(this);
		this.loadDataUserByClick = this.loadDataUserByClick.bind(this);
		this.viewContentData = this.viewContentData.bind(this);
	}
	
	componentDidMount(){		
		// Redirect user to the main Page if it is NOT allowed here
		if(DB.adminUid.indexOf(this.props.getUser().uid) === -1){
			this.props.filter(false)
			return
		}

		this.loadDataUserByClick()
	}
	/*
	loadUsersFromDb(){
		var self = this
		console.info('Users loaded');
		DB.init(firebase).load("users", {orderByKey: true}, (data) => {
			let d = data.val()
	
			if(d){
				this.props.users(d)
			}
		})
	}*/

	loadDataUserByClick(uidA){
		let self = this,
			uid = uidA || this.props.match.params.uid

		if(!uid)
			return false

		console.info('Notes loaded for:' + uid);

		DB.init(firebase).load("Notes/"+uid, {once: true, orderByKey: true}, (data) => {
			let d = data.val()

			if(d){
				self.setState(Object.assign(self.state, {"userSelected": { "uid": uid, "data": d }}))
			}else // erase data from our UI
				self.setState(Object.assign(self.state, {"userSelected": { "uid": false, "data": false }}))
		})
	}


	clickOverWeekNbr(filter){
		console.log(filter.week);
		//this.props.weekNbr(filter.week)
		this.props.filter(Object.assign(this.props.filter(), filter))
	}

	viewContentData(){
		let dataOut = {menu: [], ctn: []}

			
		if("uid" in this.props.match.params){
			//console.log(this.props.match.params);

			let userData = this.state.userSelected.data,
				uid = this.state.userSelected.uid
			let i=0

			for (const year in userData) {
				if (userData.hasOwnProperty(year)) {
					const obj = userData[year];
					dataOut.menu.push(
						<a key={year} className={(i === 0? "active" : "") + " list-group-item list-group-item-action"} id={"list-year-"+year+"-list"} data-toggle="list" role="tab" aria-controls="home" href={"#list-year-"+year}>{year}</a>
					)
	
					let newTabVal = []
					Object.keys(obj).sort((a, b) => b - a).forEach(weekNbr => {
						newTabVal.push(
							<div key={weekNbr} onClick={() => this.clickOverWeekNbr({"year": year, "week": weekNbr, "uid": uid})} className="list-group-item list-group-item-action">{weekNbr} (<span className="fontSize13">{moment().week(weekNbr).day(0).format('MM-DD-YYYY')} to {moment().week(weekNbr).day(6).format('MM-DD-YYYY')})</span></div>
						)
					});

					dataOut.ctn.push(
						<div key={i+"-line"} className={(i === 0? "active show" : "") + " tab-pane fade cursorPointer"} id={"list-year-"+year} role="tabpanel" aria-labelledby={"list-year-"+year+"-list"}>
							<div className="list-group">
								{newTabVal}
							</div>
						</div>
					)
					i++
				}
			}

			return (
				<div className="row mt-3">
					<div className="col-4">
						<div className="list-group" id="list-tab" role="tablist">
							{dataOut.menu}
						</div>
					</div>
					<div className="col-8">
						<div className="tab-content" id="nav-tabContent">
							{dataOut.ctn}
						</div>
					</div>
				</div>
			)
		}
	}

	addUsersIntoView(){
		let htmlOut = [],
			users = this.props.users()
			

		for (const uid in users) {
			if (users.hasOwnProperty(uid)) {
				const obj = users[uid];
				htmlOut.push(
					<NavLink onClick={() => {
						//this.setState(Object.assign(this.state, {"userSelected": { "uid": uid }}))
						this.loadDataUserByClick(uid)
					}} key={uid} className="list-group-item list-group-item-action" to={"/account/" + uid}>{obj.email}</NavLink>
				)
			}
		}
		return (htmlOut)
	}

	render() {
		return (
			<div>
				<div className="container ctnNote shadow p-3 mb-5 bg-white rounded border">
					<h4>List of users</h4>
					<div className="row">
						<div className="col-4">
							{ this.addUsersIntoView() }
						</div>
						<div className="col-8">
							{ this.viewContentData() }
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(Account);



// WEBPACK FOOTER //
// ./src/Pages/Account.js